// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LOGIN_BUTTON = "Prihl\u00e1s ma";
export const SEO_TITLE_LOGIN = "Prihl\u00e1senie";
